export const TRADING_ECONOMICS_COUNTRIES = [
  "Mongolia",
  "Montenegro",
  "Germany",
  "Israel",
  "Paraguay",
  "Switzerland",
  "Euro Area",
  "Romania",
  "European Union",
  "Turkey",
  "Belarus",
  "Norway",
  "Armenia",
  "Japan",
  "United States",
  "Dominican Republic",
  "Ireland",
  "Spain",
  "Croatia",
  "Austria",
  "South Africa",
  "Slovenia",
  "Georgia",
  "India",
  "Pakistan",
  "Bulgaria",
  "Serbia",
  "Italy",
  "New Zealand",
  "China",
  "Thailand",
  "Macedonia",
  "Finland",
  "Greece",
  "Singapore",
  "Ukraine",
  "South Korea",
  "Palestine",
  "Slovakia",
  "Poland",
  "Czech Republic",
  "Taiwan",
  "Hong Kong",
  "Argentina",
  "Lithuania",
  "Colombia",
  "Portugal",
  "Canada",
  "Ecuador",
  "Saudi Arabia",
  "Sweden",
  "Belgium",
  "Russia",
  "Moldova",
  "France",
  "Chile",
  "Botswana",
  "Brazil",
  "Uzbekistan",
  "Uruguay",
  "Latvia",
  "Australia",
  "Peru",
  "Malaysia",
  "Indonesia",
  "Hungary",
  "Netherlands",
  "Namibia",
  "United Kingdom",
  "Albania",
  "Mexico",
  "Philippines",
  "Malta",
  "Macau",
  "Rwanda",
  "Sri Lanka",
];

export const TRADING_ECONOMICS_COUNTRY_OPTIONS =
  [...TRADING_ECONOMICS_COUNTRIES]
    .sort((left, right) => left.localeCompare(right))
    .map((country) => ({
      value: country,
      label: country,
    }));
